// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"ba9722d4","276":"d8776d66","309":"0baac2db","325":"261d2c67","355":"8c88c049","386":"7dcfd0ec","409":"245be947","453":"926f0775","786":"7f5dc5f8","987":"f9f41d31"}[chunkId] + ".chunk.js";
};